import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export function useUserProviders(userId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.userProvidersById(userId!),
    queryFn: () => api.getUserProvidersById(userId!),
    enabled: !!userId,
  });
}
